import { render, staticRenderFns } from "./PvzMap.vue?vue&type=template&id=8072f130&scoped=true"
import script from "./PvzMap.vue?vue&type=script&lang=js"
export * from "./PvzMap.vue?vue&type=script&lang=js"
import style0 from "./PvzMap.vue?vue&type=style&index=0&id=8072f130&prod&lang=less"
import style1 from "./PvzMap.vue?vue&type=style&index=1&id=8072f130&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8072f130",
  null
  
)

export default component.exports